module.exports = __webpack_public_path__ + "static/media/university-tree-l.4b360e38.png";